import { ComponentProps, FC } from 'react';
import { useApiQuery } from '../query/hooks';
import { LoadableSelect } from '../form/LoadableSelect';
import { MenuItem, Select } from '@mui/material';
import { graphql } from '../gql';
import { useIntl } from 'react-intl';

const listJourneyQuery = graphql(`
	query journeySelect_listJourney {
		listJourney(filter: { isTemplate: { eq: false } }) {
			id
			name
		}
	}
`);

type Props = ComponentProps<typeof Select<string>> &
	Readonly<{
		loading?: boolean;
	}>;

const JourneySelect: FC<Props> = ({ value, loading, ...props }) => {
	const { isLoading: isQueryLoading, data } = useApiQuery(listJourneyQuery);
	const intl = useIntl();

	return (
		<LoadableSelect
			{...props}
			loading={loading || isQueryLoading}
			noItemsText={intl.formatMessage({ id: 'journey-select.no-items' })}
			value={value || '' /* value cannot be undefined in order to keep the input controlled */}
		>
			{data?.listJourney.map((journey) => (
				<MenuItem key={journey.id} value={journey.id}>
					{journey.name}
				</MenuItem>
			))}
		</LoadableSelect>
	);
};

export { JourneySelect };
